import Section from 'app/frontend/base/components/Section'
import { usePageInfo } from 'app/frontend/base/config/queries'
import { useTranslation } from 'react-i18next'
import SubscriptionInfo from './components/SubscriptionInfo'
import LegacySubscriptionInfo from './components/LegacySubscriptionInfo'
import PremiumModal from 'app/frontend/base/components/PremiumModal'
import { Button } from '@/components/ui/button'
import RefreshPatreonButton from 'app/frontend/base/components/RefreshPatreonButton'
import Card from 'app/frontend/base/components/Card'
import { useSubscription } from 'app/frontend/base/hooks/useSubscription'

const UserPremiumStatus = () => {
  const { t } = useTranslation()
  const {
    data: { user },
  } = usePageInfo()

  const patreonAccount = user?.linkedAccounts?.find(
    (account) => account.displayType === 'Patreon',
  )

  const {
    declined,
    subscription,
    legacySubscription,
    subscriptionColor,
    subscriptionActive,
  } = useSubscription(user)

  return (
    <Section title='Profile'>
      <h2>{t('shared.premium')}</h2>
      <Card
        className={`py-4 px-5 my-2 border-2 ${subscriptionColor.border} max-w-200`}
      >
        {subscription?.active && subscription.tierName ? (
          <SubscriptionInfo
            subscription={subscription}
            color={subscriptionColor.text}
          />
        ) : legacySubscription?.details?.pledge_tier ? (
          <LegacySubscriptionInfo
            subscription={legacySubscription}
            color={subscriptionColor.text}
          />
        ) : (
          <div>
            <h5 className='mb-4'>Not subscribed</h5>
            {declined ? (
              <p>
                Your Patreon payment status is declined. If this is incorrect,
                please reach out on Discord.
              </p>
            ) : patreonAccount ? (
              <p>
                No active pledge was found on your Patreon account. If this is
                incorrect, please reach out on Discord.
              </p>
            ) : (
              <p>
                If you have a pledge on Patreon, please{' '}
                <a href='/auth/patreon' className='text-primary'>
                  connect
                </a>{' '}
                your Patreon account.
              </p>
            )}
          </div>
        )}

        <div className='mt-4 flex gap-2'>
          <PremiumModal>
            <Button variant='outline'>
              {subscriptionActive ? 'Change subscription' : 'Subscribe now'}
            </Button>
          </PremiumModal>

          {patreonAccount ? <RefreshPatreonButton /> : null}
        </div>
      </Card>
    </Section>
  )
}

export default UserPremiumStatus
